







































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { BoolEnum } from "@/enum/index";
@Component({
  name: "Approve",
  components: {
    MaskComponent: () => import("@/components/MaskComponent.vue"),
  },
})
export default class Approve extends Vue {
  @Provide() private isSearchFormActionDone: boolean = false; // 提交按钮loading
  @Provide() private labelPosition: string = "left"; // label位置
  @Provide() private isPassActive: number = -1; // label位置
  @Provide() private labelWidth: string = "30%"; // label宽度
  // @Provide() private ReduceStatus: number | null = null; // 审批状态
  @Provide() private IsPassed: number | null = null; // 审批是否通过
  // int64 Id = 2; // 申请id
  // ReduceStatus ReduceStatus = 3; // 审批状态
  // string AuditMark = 4; // 审批备注
  @Prop() ApproveProp!: {
    Id: number;
    reduceid: number;
    list: any[];
  }; // { Id, ReduceStatus}
  @Provide() private searchForm: any = {
    AuditMark: "",
  };
  // 审核操作，更改审核状态
  private PassAction(index: number) {
    this.isPassActive = index;
    switch (index) {
      case 0:
        this.IsPassed = BoolEnum.BOOL_UNSPECIFIED;
        break;
      case 1:
        this.IsPassed = BoolEnum.BOOL_YES;
        break;
      case 2:
        this.IsPassed = BoolEnum.BOOL_NO;
        break;
    }
  }
  private SubmitAction() {
    this.isSearchFormActionDone = true;
    this.submitRequest();
  }
  // 验证提交表单是否合法
  private validateForm(): boolean {
    if (this.IsPassed) {
      return true;
    } else {
      this.$message({
        type: "warning",
        message: "pls chose the Approval Status",
      });
      return false;
    }
  }
  // 处理提交审核
  private dwGetListFuc() {
    return {
      Auditmark: this.searchForm.AuditMark,
      IsPassed: this.IsPassed,
      // Id: +this.ApproveProp.Id
      ReduceId: this.ApproveProp.reduceid,
    };

    console.log(this.searchForm.AuditMark);
    console.log(this.IsPassed);
    console.log(+this.ApproveProp.reduceid);
  }
  // 提交审核
  private async submitRequest() {
    if (this.validateForm()) {
      const { setSaveReduceReq, saveReduceRequest }: any = await import(
        "@/request/getReduceList"
      );
      console.log(this.dwGetListFuc(), "saveReduceRequest");
      let res = await saveReduceRequest.handleHttp(
        setSaveReduceReq(this.dwGetListFuc()),
        null
      );
      console.log(typeof res, res, "saveReduceRequest");
      this.isSearchFormActionDone = res ? res.loading : false;
      if (res && res.right) {
        this.$message({
          type: "success",
          message: "succcess",
        });
        this.hideMask();
      }
    }
  }
  private hideMask() {
    this.$emit("hideDialog", {
      hidden: true,
      val: null,
    });
  }
  private created() {
    console.log(this.ApproveProp);
  }
}
